"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Keyboard_1 = require("../../../_Core/Keyboard");
var Localization_1 = require("../../../Localization");
var Searcher_1 = require("../../../Searcher");
var SearchableNestedDropdown_context_1 = require("../SearchableNestedDropdown.context");
var Header_styles_1 = require("./Header.styles");
exports.default = React.forwardRef(function (_, ref) {
    var _a = React.useContext(SearchableNestedDropdown_context_1.SndContext), SearchPlaceholder = _a.SearchPlaceholder, Search = _a.Search, ClearControl = _a.ClearControl, SearchString = _a.SearchString, SelectItemInDropdown = _a.SelectItemInDropdown;
    var searcherRef = React.createRef();
    React.useEffect(function () {
        searcherRef.current.focus();
    }, []);
    React.useImperativeHandle(ref, function () { return ({
        focusHeaderControl: function () {
            searcherRef.current.focus();
            searcherRef.current.select();
        },
    }); });
    var handleOnSearch = function (search) {
        Search(search);
    };
    var handleOnSearchClear = function () {
        ClearControl();
    };
    var handleOnKeyUp = function (e) {
        if (Keyboard_1.IsEscape(e)) {
            ClearControl();
        }
        else if (Keyboard_1.IsDownArrow(e)) {
            SelectItemInDropdown();
        }
    };
    return (React.createElement(Header_styles_1.SearchHeader, null,
        React.createElement(Searcher_1.Searcher, { AriaLabel: Localization_1.strings.SND_Label_Search, InitialSearch: SearchString, OnClear: handleOnSearchClear, OnKeyUp: handleOnKeyUp, OnSearch: handleOnSearch, Placeholder: SearchPlaceholder, ref: searcherRef })));
});
